/**
 * PopupListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  ModalLayout,
  InputFormTable,
  HtmlContent,
} from 'components';
import { Button, Input, Radio, Switch, Avatar } from 'antd';
import moment from 'moment';

const PopupListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isOpened, setIsOpened] = useState(false);
  const [modalType, setModalType] = useState('CREATE');

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '구분',
      form: [
        {
          input: (
            <Radio.Group value={'전체'}>
              <Radio value={'전체'}>전체</Radio>
              <Radio value={'PC'}>PC</Radio>
              <Radio value={'모바일'}>모바일</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '위치',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              PC메인
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              모바일 메인
            </Button>
          ),
        },
      ],
    },
    {
      label: '검색어',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 400 }}
              />
            </>
          ),
        },
      ],
    },
  ];

  const form = [
    {
      label: '제목',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="새 팝업의 제목을 입력해주세요"
              style={{ ...styles.form.input.large, width: 400 }}
            />
          ),
          count: true,
          maxLength: 50,
        },
      ],
    },
    {
      label: '내용',
      form: [
        {
          input: <div style={{ height: 430 }}>에디터!!!!</div>,
        },
      ],
    },
    {
      label: '크기',
      form: [
        {
          input: (
            <>
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>너비</p>
              <Input
                size="large"
                placeholder="400"
                style={{ ...styles.form.input.medium }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>px</p>
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>/</p>
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>높이</p>
              <Input
                size="large"
                placeholder="500"
                style={{ ...styles.form.input.medium }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>px / </p>
            </>
          ),
        },
      ],
    },
    {
      label: '위치',
      form: [
        {
          input: (
            <Radio.Group value={'전체'}>
              <Radio value={'전체'}>전체</Radio>
              <Radio value={'PC'}>PC</Radio>
              <Radio value={'모바일'}>모바일</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 10; i++) {
    newData.push({
      no: i + 1,
      구분: (
        <span
          style={{
            color: '#5F646F',
          }}
        >
          {i < 5 ? 'PC(메인)' : '모바일(메인)'}
        </span>
      ),
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Avatar size={31} shape="square" style={{ marginRight: 10 }} />
          <p>팝업입니다{i}</p>
        </div>
      ),
      created_at: new Date(),
      미리보기: <Button type="primary">미리보기</Button>,
      is_show: <Switch size="large" />,
    });
  }

  /* ===== FUNCTION ===== */
  /**
   * 모달 핸들러
   * --
   */
  const handleOpenModal = (t = 'CREATE', d) => {
    const type = t.toLocaleUpperCase();
    setModalType(type);

    switch (type) {
      case 'CREATE':
        break;
      case 'UPDATE':
        break;
      case 'DETAIL':
        break;
      default:
        break;
    }

    setIsOpened(!isOpened);
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>팝업 관리</Title>

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40 }}
            >
              <ExpandableContainer borderRadius={4} padding={20}>
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 20,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                >
                  검색
                </Button>
                <Button size="large" style={{ ...styles.button }}>
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}
            </Content>
            {/* 검색필터 끝 */}

            {/* 검색결과 */}
            <Content maxWidth={'100%'} borderRadius={4} padding={20}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                  총 <span>0</span>개
                </h4>
                <Button
                  size="large"
                  style={{ marginRight: 8 }}
                  onClick={() => handleOpenModal('create')}
                >
                  새 팝업
                </Button>
              </div>
              <Table
                data={newData}
                isChecked
                columns={[
                  {
                    title: 'No',
                    key: 'no',
                    width: 10,
                  },
                  {
                    title: '구분(위치)',
                    key: '구분',
                  },
                  {
                    title: '제목',
                    key: 'title',
                    width: 500,
                    align: 'left',
                    style: {
                      padding: 8,
                    },
                  },
                  {
                    title: '등록일',
                    key: 'created_at',
                    render: (item) => moment(item).format('YYYY-MM-DD'),
                  },
                  {
                    title: '미리보기',
                    key: '미리보기',
                  },
                  {
                    title: '노출여부',
                    key: 'is_show',
                  },
                ]}
              />
            </Content>
            {/* 검색결과 끝 */}
          </Col>
        </Row>
      </Content>

      <ModalLayout
        type={'modal'}
        open={isOpened}
        onCancel={setIsOpened}
        centered
        closable
        title={
          modalType === 'CREATE'
            ? '새 팝업'
            : modalType === 'UPDATE'
            ? '팝업 수정'
            : '팝업 상세보기'
        }
        width={798}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={8} style={{ textAlign: 'left', display: 'flex' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      lineHeight: '133%',
                      paddingRight: 5,
                    }}
                  >
                    노출여부
                  </p>
                  <Switch />
                </div>
              </Col>
              <Col x={8} style={{ textAlign: 'center' }}></Col>
              <Col x={8}>
                {modalType === 'DETAIL' ? (
                  <Button style={{ ...styles.button }}>편집</Button>
                ) : (
                  <>
                    <Button style={{ ...styles.button }}>취소</Button>
                    <Button
                      type="primary"
                      style={{
                        ...styles.button,
                        background: 'var(--primary-color)',
                      }}
                    >
                      등록
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              {modalType === 'DETAIL' ? (
                <div>
                  <div style={{ borderBottom: '1px solid #F4F4F5' }}>
                    <h4
                      style={{
                        fontSize: 23,
                        fontWeight: 400,
                        marginBottom: 10,
                      }}
                    >
                      새로운 공지사항이 등록되었습니다. 확인 후 적용해주세요.
                    </h4>
                    <div
                      style={{
                        display: 'flex',
                        fontSize: 12,
                        fontWeight: 400,
                        marginBottom: 10,
                      }}
                    >
                      <p style={{ marginRight: 16 }}>
                        작성자: <span style={{ color: '#8A8A8A' }}>관리자</span>
                      </p>
                      <p>
                        작성일:{' '}
                        <span style={{ color: '#8A8A8A' }}>
                          {new Date().toString()}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    style={{ height: 500, overflow: 'auto', padding: '16px 0' }}
                  >
                    <HtmlContent content={`<div>내용입니다</div>`} />
                  </div>
                </div>
              ) : (
                <InputFormTable form={form} labelWidth={148} />
              )}
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default PopupListPresenter;
